import type { BackendLead, BackendLeadStatus, LeadItem, LeadStatus } from "../types/lead.types";

export type CreateLeadRequest = {
	fullName: string;
	phone?: string;
	email?: string;
	source?: BackendLead["source"];
	buildingId?: string;
	responsibleUserId?: string;
	statusId?: string;
};

export type UpdateLeadStatusRequest = {
	statusId: string;
	responsibleUserId?: string;
};

export function mapBackendLead(backend: BackendLead): LeadItem {
	const status = backend.status ?? null;
	const responsible = backend.responsible ?? null;

	return {
		id: backend.id,
		name: backend.fullName,
		phone: backend.phone ?? "",
		source: backend.source,
		managerName: responsible?.fullName ?? "",
		managerInitials: responsible?.fullName
			? responsible.fullName
					.split(" ")
					.map((part) => part[0])
					.join("")
					.slice(0, 2)
					.toUpperCase()
			: "",
		buildingId: backend.buildingId ?? null,
		buildingName: "",
		budget: "",
		roomInterest: "",
		calls: backend.unreadCallsCount ?? 0,
		email: backend.email ?? undefined,
		statusId: status?.id ?? backend.statusId ?? "",
		createdAt: backend.createdAt,
		lastActivity: backend.updatedAt ?? backend.createdAt,
	};
}

export function mapBackendLeadStatus(backend: BackendLeadStatus): LeadStatus {
	return {
		id: backend.id,
		name: backend.nameUz,
		nameRu: backend.nameRu ?? "",
		color: backend.color,
		order: backend.indexOrder,
	};
}

export function toCreateLeadRequest(
	name: string,
	phone: string,
	email: string,
	source: BackendLead["source"],
	statusId?: string,
	buildingId?: string,
	responsibleUserId?: string
): CreateLeadRequest {
	return {
		fullName: name.trim(),
		phone: phone.trim() || undefined,
		email: email.trim() || undefined,
		source,
		...(statusId ? { statusId } : {}),
		...(buildingId ? { buildingId } : {}),
		...(responsibleUserId ? { responsibleUserId } : {}),
	};
}

export function toUpdateLeadStatusRequest(
	statusId: string,
	responsibleUserId?: string
): UpdateLeadStatusRequest {
	return {
		statusId,
		...(responsibleUserId ? { responsibleUserId } : {}),
	};
}
